<template>
  <div id="app">
    <transition name="page" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
   // Login,
  }
}
</script>

<style>
  *:focus{
    outline: none !important;
  }
  html, body, #app{
    width: 100% !important;
    height: 100% !important;
  }
  .page-enter-active,
  .page-leave-active,
  .page-leave-to,
  .page-enter-to,
  .page-enter{
    transition: opacity .3s;
    opacity: 0;
  }
  .button:focus{
    outline: 0px!important;
  }
</style>
